import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CurrentShopSelect } from "@/components/layout/shop-scope-select";
import { StrategyLabPage } from "@/components/strategy-lab/StrategyLabPage";
import { requireModule } from "@/lib/module-access";

const searchSchema = z.object({
  category: z.enum(["builtin", "custom", "ai"]).optional().catch(undefined),
  view: z.enum(["library", "distill", "learn"]).optional().catch(undefined),
  strategyId: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_authed/strategy-lab")({
  beforeLoad: () => requireModule("ai"),
  validateSearch: (search) => searchSchema.parse(search),
  component: StrategyLabRoute,
});

function StrategyLabRoute(): React.ReactElement {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <>
      <div className="flex justify-end px-8 pt-5">
        <CurrentShopSelect />
      </div>
      <StrategyLabPage
        {...search}
        onSearchChange={(next) => {
          void navigate({ search: next, replace: true });
        }}
      />
    </>
  );
}
